// https://zeroheight.com/2d379a49f/p/4402fd-typography-/t/21607a

.button-text {
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 400;
}
